<template>
  <div class="product-videos">
    <input type="hidden" name="videos" id="videos" v-model="videosImploded" />

    <div class="loading"
         v-show="loading">
      <div class="fa-3x">
        <i class="fas fa-spinner fa-pulse"></i>
      </div>
    </div>
    <input type="file"
           style="display: none"
           name="newVideo"
           accept="video/*"
           id="newVideo"
           v-on:change="addFile($event)"
    />

    <table class="table table-sm">
      <thead>
        <tr>
          <th>#</th>
          <th>Preview</th>
          <th>Link</th>
          <th>Title</th>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(video, index) in product.videos"
            :key="index">
          <td>{{ index + 1 }}</td>
          <td>
            <video controls
                   crossorigin
                   :src="video.link"
                   style="width: 200px"></video>
          </td>
          <td>
            <input type="url"
                   v-model="video.link"
                   :name="'video-'+index"
                   required
                   placeholder="Enter video URL"
                   class="form-group grey-input white"
            />
            or
            <label class="button button-primary-outline"
                   for="newVideo"
                    @click="startUpload(index)">
              <i class="fas fa-circle-plus"></i>
              Upload video
            </label>
          </td>
          <td>
            <input type="text"
                   v-model="video.title"
                   placeholder="Video title"
                   class="form-group grey-input white"
            />
          </td>
          <td>
            <textarea type="text"
                      v-model="video.description"
                      placeholder="Video title"
                      rows="4"
                      class="form-group grey-input white"
            ></textarea>
          </td>
          <td>
            <div class="actions">
              <button class="button action remove"
                      type="button"
                      @click="remove(index)">
                <i class="far fa-trash-alt"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="5">
            <button class="btn btn-success"
                    type="button"
                    @click="add">
              Add video
            </button>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: "ProductsVideos",
  props: ['product'],
  data() {
    return {
      loading: false,
      uploadingVideoIndex: ''
    }
  },
  methods: {
    startUpload(index) {
      this.uploadingVideoIndex = index
    },
    addFile(event) {
      let file = event.target.files[0];

      if (!file) {
        return
      }

      this.uploadToServer(file)
    },
    uploadToServer(file) {
      let formData = new FormData();
      formData.append('video', file)
      this.loading = true

      axios.post('/products/upload_video',
          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then((r) => {
        this.product.videos[this.uploadingVideoIndex].link = r.data.link
        this.uploadingVideoIndex = -1
        $('#newVideo')[0].file = null
        $('#newVideo').val(null)

      }).finally(() => {
        this.loading = false
      })
    },
    add() {
      this.product.videos.push({
        "link": '',
        "title": '',
        "description": '',
      })
    },
    remove(index) {
      let video = this.product.videos[index]

      if (!video.link) {
        return this.product.videos.splice(index, 1)
      }

      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this video?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.product.videos.splice(index, 1)
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    },
  },
  computed: {
    videosImploded(){
      return JSON.stringify(this.product.videos)
    }
  }
}
</script>

<style scoped>

</style>
